// src/belediye/services/sistemApi.js
//
// FAZ-15 — Sistem Yönetimi API katmanı (ADIM 0 uçlarını tüketir).
// Roller, üyelik/atama (tek-rol deneyimi: `role` = role_ref kodu), birim ağacı,
// kullanıcılar, efektif izin simülatörü. Tüm uçlar backend'de role_ref gate'li.
//
// Not: bu uçlar GLOBAL — belediyeApi.js interceptor'ında X-Unit-Slug'tan muaf.

import api from "./belediyeApi";

const clean = (obj) =>
  obj && typeof obj === "object"
    ? Object.fromEntries(
        Object.entries(obj).filter(([, v]) => v !== undefined && v !== null && v !== "")
      )
    : obj;

// DRF sayfalı ({results}) ya da düz liste → düz dizi
const asList = (data) =>
  Array.isArray(data?.results) ? data.results : Array.isArray(data) ? data : [];

// ── Kullanıcılar ─────────────────────────────────────────────────────────────
export const fetchSistemUsers = (params = {}) =>
  api.get("/common/users/", { params: clean(params) }).then((r) => asList(r.data));

export const createSistemUser = (payload) =>
  api.post("/common/users/", payload).then((r) => r.data);

export const fetchEffectivePermissions = (userId, unitId) =>
  api
    .get(`/common/users/${userId}/effective-permissions/`, { params: clean({ unit: unitId }) })
    .then((r) => r.data);

// FAZ-23 — hesap/güvenlik (Personel'den taşındı):
// login-logs (users.logs.view) + şifre sıfırlama (users.password.reset), backend gate'li.
export const fetchUserLoginLogs = (userId) =>
  api.get(`/common/users/${userId}/login-logs/`).then((r) => asList(r.data));

export const resetUserPassword = (userId) =>
  api.post(`/common/users/${userId}/reset-password/`).then((r) => r.data);

// Seçili kullanıcı(lar)ın parolasını yeniden üretip SMS ile gönderir (tekli kart
// butonu tek elemanlı dizi geçer, toplu işlem tüm seçilenleri). Parola dönmez.
export const sendPasswordSms = (userIds) =>
  api
    .post("/common/users/send-password-sms/", { user_ids: userIds })
    .then((r) => r.data);

// Toplu aktif/pasif (görev/erişim durumu) — izin: users.update
export const bulkSetActive = (userIds, isActive) =>
  api
    .post("/common/users/bulk-set-active/", { user_ids: userIds, is_active: isActive })
    .then((r) => r.data);

// Toplu silme (geri alınamaz) — izin: users.delete
export const bulkDeleteUsers = (userIds) =>
  api
    .post("/common/users/bulk-delete/", { user_ids: userIds })
    .then((r) => r.data);

// ── Roller ───────────────────────────────────────────────────────────────────
export const fetchRoles = () => api.get("/common/roles/").then((r) => asList(r.data));
export const fetchRole = (id) => api.get(`/common/roles/${id}/`).then((r) => r.data);
export const createRole = (payload) => api.post("/common/roles/", payload).then((r) => r.data);
export const updateRole = (id, payload) =>
  api.patch(`/common/roles/${id}/`, payload).then((r) => r.data);
export const deleteRole = (id) => api.delete(`/common/roles/${id}/`).then((r) => r.data);

// ── Üyelik / atama (role = role_ref kodu) ────────────────────────────────────
export const fetchUnitMemberships = (params = {}) =>
  api.get("/common/unit-memberships/", { params: clean(params) }).then((r) => asList(r.data));
export const createMembership = (payload) =>
  api.post("/common/unit-memberships/", payload).then((r) => r.data);
export const updateMembership = (id, payload) =>
  api.patch(`/common/unit-memberships/${id}/`, payload).then((r) => r.data);
export const deleteMembership = (id) =>
  api.delete(`/common/unit-memberships/${id}/`).then((r) => r.data);

// ── Birim ağacı ──────────────────────────────────────────────────────────────
export const fetchSistemUnitsTree = () =>
  api.get("/common/sistem-units/tree/").then((r) => r.data);
export const fetchSistemUnits = () =>
  api.get("/common/sistem-units/").then((r) => asList(r.data));
export const createUnit = (payload) =>
  api.post("/common/sistem-units/", payload).then((r) => r.data);
export const updateUnit = (id, payload) =>
  api.patch(`/common/sistem-units/${id}/`, payload).then((r) => r.data);

// ── İzin kataloğu (module_key + description) ──────────────────────────────────
export const fetchFeatureActions = () =>
  api.get("/common/feature-actions/").then((r) => asList(r.data));

// Ağaç düğümlerini düz "value/label" listesine indirger (birim dropdown'ı için)
export const flattenUnitTree = (nodes, depth = 0, acc = []) => {
  (Array.isArray(nodes) ? nodes : []).forEach((n) => {
    acc.push({ id: n.id, slug: n.slug, name: n.name, depth });
    if (n.children?.length) flattenUnitTree(n.children, depth + 1, acc);
  });
  return acc;
};
